import { gql } from '@apollo/client';

export const BreadcrumbsFragment = gql`
  fragment BreadcrumbsFragment on Product {
    breadcrumbs {
      key: id
      link: url
      name: title
    }
  }
`;

export default {};
